import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ToggleContainer, ToggleSlider, ToggleInput, CustomIcon } from './mixins';
export var Toggle = function Toggle(_ref) {
  var _onChange = _ref.onChange,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;

  var _useState = useState(isChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checkStatus = _useState2[0],
      setCheckStatus = _useState2[1];

  var _useContext = useContext(ThemeContext),
      colors = _useContext.colors;

  var iconZise = {
    small: '12',
    medium: '13',
    large: '16'
  };

  var setIconColor = function setIconColor() {
    if (disabled) {
      return colors.grey24;
    }

    if (!checkStatus) {
      return colors.grey0;
    }

    return colors.primary.normal;
  }; // Actualizar valor


  useEffect(function () {
    setCheckStatus(isChecked);
  }, [isChecked]);
  return React.createElement(ToggleContainer, {
    size: size
  }, React.createElement(ToggleInput, {
    onChange: function onChange(event) {
      if (!disabled) {
        setCheckStatus(!checkStatus);
        _onChange && _onChange(event);
      }
    },
    type: "checkbox",
    checked: checkStatus
  }), React.createElement(ToggleSlider, {
    disabled: disabled,
    checked: checkStatus,
    size: size
  }, React.createElement(CustomIcon, {
    name: "icon-light-".concat(checkStatus ? 'checkmark' : 'close'),
    color: setIconColor(),
    size: iconZise[size],
    position: size,
    checked: checkStatus
  })));
};